import teamSetupPickerStore from "../store/store";
import { mutatorAction } from "satcheljs";
import { TeamSetupPickerStepState } from "../store/schema/TeamSetupPickerStore";
import { trace } from "owa-trace";

/**
 * Updates the current step in the team setup flow to the prev state.
 * Resets the sequence to default (TimeZonePicker) when navigating back to MSTeamPicker.
 */
export default mutatorAction('GOTO_PREV_SETUP_STEP', function gotoPrevSetupStep() {
    if (teamSetupPickerStore.setupSequence &&
        (teamSetupPickerStore.currentSetupStepIndex > 0)) {

        const prevStepIndex = teamSetupPickerStore.currentSetupStepIndex - 1;
        const prevStep = teamSetupPickerStore.setupSequence[prevStepIndex];

        // If navigating back to MSTeamPicker, reset the sequence to default
        // This ensures a clean state for the next team selection
        if (prevStep === TeamSetupPickerStepState.MSTeamPicker &&
            prevStepIndex < teamSetupPickerStore.setupSequence.length - 1) {
            const nextStepIndex = prevStepIndex + 1;
            const currentNextStep = teamSetupPickerStore.setupSequence[nextStepIndex];

            // Reset to default only if the next step is RestoreSchedule or TimeZonePicker
            if (currentNextStep === TeamSetupPickerStepState.RestoreSchedule ||
                currentNextStep === TeamSetupPickerStepState.TimeZonePicker) {
                teamSetupPickerStore.setupSequence[nextStepIndex] = TeamSetupPickerStepState.TimeZonePicker;
            }
        }

        teamSetupPickerStore.currentSetupStepIndex--;
    } else {
        trace.warn("Team setup: error with gotoPrevSetupStep occurred");
    }
});
